/* eslint-disable prettier/prettier */
import CryptoJS from './CryptoJS/aes'
import './CryptoJS/mode-ecb-min'
/**
 * @file 加密解密方法
 */
let passwordKey = 'MV&4vCJzy93hKt8S'
let passport = {
	/**
	 * @function encrypt 加密
	 * @param {*} word 
	 */
	encrypt(word) {
		var srcs = CryptoJS.enc.Utf8.parse(word);
		var key = CryptoJS.enc.Utf8.parse(passwordKey)
		var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
		return encrypted.toString();
	},
	decrypt(word) {
		var key = CryptoJS.enc.Utf8.parse(passwordKey)
		var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
		return CryptoJS.enc.Utf8.stringify(decrypt).toString();
	}
}

export default passport;
